import config from './config';
const { baseUrl } = config();

const cta = () => {
	const ctaEmailField = document.querySelectorAll('.pushengage-cta-test-drive-form__input');
	const ctaTestDriveBtn = document.querySelectorAll('.pushengage-cta-test-drive-form__button');

	if (!ctaTestDriveBtn && !ctaEmailField) {
		return null;
	}

	ctaTestDriveBtn.forEach((testDriveBtn, index) => {
		testDriveBtn.addEventListener('click', () => {
			if (ctaEmailField[index] && '' !== ctaEmailField[index].value) {
				localStorage.setItem('pe_cta_user_email', ctaEmailField[index].value);
				const ep =
					'/wp-admin/admin-ajax.php?people=' +
					ctaEmailField[index].value +
					'&action=pdrl&emdrip=' +
					document.getElementById('emdrip').value;
				const epTrack = new Image();
				epTrack.onload = function () {
					window.location.href = `${baseUrl}/pricing`;
				};

				epTrack.onerror = function () {
					window.location.href = `${baseUrl}/pricing`;
				};

				epTrack.src = ep;
			} else {
				window.location.href = `${baseUrl}/pricing`;
			}
		});
	});
};

export default cta;
